import controller from './chart-container-controller';

const ChartContainerComponent: angular.IComponentOptions = {
  controller: controller,
  controllerAs: 'ctrl',
  bindings: {
    dataset: '<',
    model: '<',
    viewName: '<',
    view: '<?setView',
    state: '<',
    status: '<?',
    chartExists: '<',
    chartId: '@id',
    onEdit: '&?',
    onAction: '&?',
    onTitleChanged: '&?',
    viewer: '<',
    panelEnabled: '<',
    isChartVisible: '<',
  },
  template: `
    <div class="chart-container-component">

      <!-- Placeholder Begins -->
      <div class="mode-placeholder" ng-show="ctrl.hasView() && ctrl.isRendering && !ctrl.isDesignerMode() && !ctrl.isLightboxMode() && !ctrl.queryFailed(dataset)" ng-class="{'loading': ctrl.isRendering}" />
      <!-- @Placeholder Ends -->

      <mode-multi-chart
        id="{{ctrl.chartId}}"
        dataset="ctrl.dataset"
        set-view="ctrl.sanitizedView"
        status="ctrl.status"
        chart-exists="ctrl.chartExists"
        viewer="ctrl.viewer"
        on-action="ctrl.onAction({ $action: $action })"
        on-edit="ctrl.onEdit({'$id': $id, '$view': $view})"
        on-render-start="ctrl.onRenderStart({'$vizID': $vizID})"
        on-render-end="ctrl.onRenderEnd({'$vizID': $vizID})"
        ng-if="ctrl.isMultiChart(ctrl.view.selectedChart)"></mode-multi-chart>
      <mode-big-number
        id="{{ctrl.chartId}}"
        dataset="ctrl.dataset"
        set-view="ctrl.sanitizedView"
        viewer="ctrl.viewer"
        on-action="ctrl.onAction({ $action: $action })"
        on-edit="ctrl.onEdit({'$id': $id, '$view': $view})",
        on-render-start="ctrl.onRenderStart({'$vizID': $vizID})"
        on-render-end="ctrl.onRenderEnd({'$vizID': $vizID})"
        ng-if="ctrl.isBigNumber(ctrl.view.selectedChart)"></mode-big-number>
      <mode-pivot-table
        id="{{ctrl.chartId}}"
        dataset="ctrl.dataset"
        view="ctrl.sanitizedView"
        viewer="ctrl.viewer"
        status="ctrl.status"
        chart-exists="ctrl.chartExists"
        on-action="ctrl.onAction({ $action: $action })"
        on-edit="ctrl.onEdit({'$id': $id, '$view': $view})"
        on-render-start="ctrl.onRenderStart({'$vizID': $vizID})"
        on-render-end="ctrl.onRenderEnd({'$vizID': $vizID})"
        panel-enabled="ctrl.panelEnabled"
        is-chart-visible="ctrl.isChartVisible"
        ng-if="ctrl.isPivotTable(ctrl.view.selectedChart)"></mode-pivot-table>
    </div>`,
};

export { ChartContainerComponent };
